<div *ngIf="agentMode" class="govuk-width-container">
	<button type="button" class="btn btn-primary" data-module="govuk-button" (click)="datastoreService?.agentRestart()">
		Agent Restart
	</button>
</div>

<div class="row breadcrumb-container">
	<div class="col-12">
		<div class="govuk-width-container">
			<govuk-ui-breadcrumb [items]="breadcrumbItems"></govuk-ui-breadcrumb>
		</div>
	</div>
</div>
<div class="govuk-width-container">
	<div class="row m-0">
		<div class="col-sm-12 p-0">
			<gb-ui-back-link (back)="routerGoBack()"></gb-ui-back-link>
		</div>
	</div>
</div>
<main id="main-content" tabindex="-1">
	<div class="row page-heading-container">
		<div class="col-12">
			<gb-ui-page-heading [titleText]="this.selectedDepartment?.extra?.review_page_title">
				<ng-template #subContent>
					<p>Your ceremony booking is almost complete. Please check the details of your booking before proceeding to confirm.</p>
				</ng-template>
			</gb-ui-page-heading>
		</div>
	</div>
	<div class="govuk-width-container">
		<div class="govuk-main-wrapper govuk-main-wrapper--l">
			<!-- <div class="row">
				<div class="col-sm-12">
					<span class="summary-notif">
						{{ 'COMMON.SUMMARY_NOTIFICATION' | translate }}
					</span>
				</div>
			</div> -->
			<div class="row" *ngIf="loggedIn">
				<div class="col-sm-12">
					<div>
						<div>
							<dl class="govuk-summary-list">
								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key" aria-label="Service Name">
										{{ 'COMMON.SERVICE_NAME' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedService?.name }}
									</dd>
								</div>
								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key" aria-label="Duration">
										{{ 'COMMON.DURATION' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedService?.calculated_duration }} minutes
									</dd>
								</div>
								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key" aria-label="Site">Venue</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedResourceObj?.name }}
									</dd>
								</div>
								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key" aria-label="Date">
										{{ 'COMMON.DATE' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{
										selectedSlot?.start
										| date
										: 'EEEE d MMMM yyyy'
										: ''
										: translateService.currentLang
										}}
									</dd>
								</div>

								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key" aria-label="Time">
										{{ 'COMMON.TIME' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedSlot?.displayTime }}
									</dd>
								</div>
							</dl>
							<dl class="govuk-summary-list" *ngFor="let detail of bookingSummaryData">
								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ detail.name | translateSplit }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ formatQuestion(detail.answer) }}
									</dd>
								</div>
							</dl>
						</div>
					</div>

					<!-- <ng-container *ngIf="adminJourney">
						<div class="govuk-summary-card">
							<form [formGroup]="adminForm" class="govuk-summary-card__content">
								<div class="govuk-form-group" [ngClass]="{
										'govuk-form-group--error':
											form.amount.errors?.required === true && adminFormSubmitted
									}">
									<h1 class="govuk-label-wrapper">
										<label class="govuk-label govuk-label--s" for="amount">
											<span aria-hidden="true" class="form-field-required-marker">
												*</span>Payment amount
										</label>
									</h1>
									<p *ngIf="form.amount?.errors && adminFormSubmitted" id="event-name-error"
										class="govuk-error-message">
										<span class="govuk-visually-hidden">Error:</span>
										{{
										'COMMON.IS_REQUIRED'
										| translate : { value: 'COMMON.ADMIN_AMOUNT' | translate }
										}}
									</p>
									<div class="govuk-input__wrapper">
										<div class="govuk-input__prefix" aria-hidden="true">£</div>
										<input class="govuk-input" id="amount" name="amount" type="text"
											formControlName="amount" />
									</div>
								</div>
								<div class="govuk-form-group" [ngClass]="{
										'govuk-form-group--error':
											form.reference.errors?.required === true &&
											adminFormSubmitted
									}">
									<h1 class="govuk-label-wrapper">
										<label class="govuk-label govuk-label--s" for="reference">
											<span aria-hidden="true" class="form-field-required-marker">
												*</span>Transaction reference generated from payment system
										</label>
									</h1>
									<p *ngIf="form.reference?.errors && adminFormSubmitted" id="event-name-error"
										class="govuk-error-message">
										<span class="govuk-visually-hidden">Error:</span>
										{{
										'COMMON.IS_REQUIRED'
										| translate : { value: 'COMMON.ADMIN_REF' | translate }
										}}
									</p>
									<input class="govuk-input" id="reference" name="reference" type="text"
										formControlName="reference" />
								</div>

								<div class="govuk-form-group" [ngClass]="{
										'govuk-form-group--error':
											form.amount.errors?.required === true && adminFormSubmitted
									}">
									<h1 class="govuk-label-wrapper">
										<label class="govuk-label govuk-label--s" for="amount">
											<span aria-hidden="true" class="form-field-required-marker">
												*</span>Type of payment
										</label>
									</h1>
									<p *ngIf="form.reference?.errors && adminFormSubmitted" id="event-name-error"
										class="govuk-error-message">
										<span class="govuk-visually-hidden">Error:</span>
										{{
										'COMMON.IS_REQUIRED'
										| translate : { value: 'COMMON.ADMIN_NOTE' | translate }
										}}
									</p>
									<select class="govuk-select" formControlName="note">
										<option></option>
										<option value="Ceremony Fee Only in Full">
											Ceremony Fee Only in Full
										</option>
										<option value="Ceremony Fee & Certificates in Full">
											Ceremony Fee & Certificates in Full
										</option>
										<option value="Ceremony Fee Deposit & Certificates in Full`">
											Ceremony Fee Deposit & Certificates in Full
										</option>
									</select>
								</div>

								<div class="govuk-form-group" [ngClass]="{
										'govuk-form-group--error':
											form.certificate_removal.errors?.required === true &&
											adminFormSubmitted
									}">
									<h1 class="govuk-label-wrapper">
										<label class="govuk-label govuk-label--s" for="reference">
											How many certificates should be removed?
										</label>
									</h1>
									<p *ngIf="form.certificate_removal?.errors && adminFormSubmitted" id="event-name-error"
										class="govuk-error-message">
										<span class="govuk-visually-hidden">Error:</span>
										{{
										'COMMON.IS_REQUIRED'
										| translate : { value: 'COMMON.ADMIN_REF' | translate }
										}}
									</p>
									<select formControlName="certificate_removal" class="govuk-select">
										<option value="0" selected>0</option>
										<option value="1">1</option>
										<option value="2">2</option>
									</select>
								</div>
							</form>
						</div>
					</ng-container> -->

					<!-- <div>
						<p class="govuk-body" *ngIf="adminJourney">
							Please confirm that you have advised the customer of their ceremony
							fees and have checked the payment information is correct.
						</p>

						<p class="govuk-body" *ngIf="!adminJourney">
							Please confirm that you understand if you click cancel in the
							payment screen or payment cannot be taken at the time of booking,
							your ceremony booking will not be confirmed.
						</p>

						<div class="govuk-checkboxes" data-module="govuk-checkboxes">
							<div class="govuk-checkboxes__item">
								<input [(ngModel)]="confirmContinue" class="govuk-checkboxes__input" id="mustConfirm"
									name="mustConfirm" type="checkbox" value="mustConfirm" />

								<label *ngIf="adminJourney" class="govuk-label govuk-checkboxes__label" for="mustConfirm">
									I confirm I have advised the customer and the payment
									information is correct
								</label>

								<label *ngIf="!adminJourney" class="govuk-label govuk-checkboxes__label" for="mustConfirm">
									* I confirm and understand the above
								</label>
							</div>
						</div>
						<br />
					</div> -->

				</div>

				<div class="row">
					<div class="col-sm-12">
						<form [formGroup]="policyForm" autocomplete="off">

							<p class="govuk-body" *ngIf="adminJourney">
								Please confirm that you have advised the customer of their ceremony
								fees and have checked the payment information is correct.
							</p>

							<p class="govuk-body" *ngIf="!adminJourney">
																Please confirm that you understand if you click cancel in the
								payment screen or payment cannot be taken at the time of booking,
								your ceremony booking will not be confirmed.
							</p>

							<div class="govuk-checkboxes" data-module="govuk-checkboxes">
								<div class="govuk-checkboxes__item">
									<input formControlName="paymentInfo" class="govuk-checkboxes__input"
										id="mustConfirm" name="mustConfirm" type="checkbox" aria-required="true" />

									<label *ngIf="adminJourney" class="govuk-label govuk-checkboxes__label"
										for="mustConfirm">
										I confirm I have advised the customer and the payment information is correct
									</label>

									<label *ngIf="!adminJourney" class="govuk-label govuk-checkboxes__label"
										for="mustConfirm">
										* Please agree before proceeding
									</label>
								</div>
							</div>

							<br />
							<!--  terms and conditions -->
							<div class="govuk-form-group" [ngClass]="{
									'govuk-form-group--error': submitted && form.tnc.errors
								}">
								<fieldset class="govuk-fieldset" aria-describedby="tnc">
									<legend
										class="govuk-fieldset__legend govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse">
										<h2>
											{{ 'FORM.TNCS.TNCS_TITLE' | translate }}
										</h2>
									</legend>

									<p class="govuk-error-message" *ngIf="submitted && form.tnc.errors">
										<span class="govuk-visually-hidden">Error:</span>
										{{ 'COMMON.IS_REQUIRED' | translate }}
									</p>

									<p class="govuk-body" [innerHTML]="selectedDepartment.extra.terms_and_conditions">
									</p>

									<div class="govuk-checkboxes" data-module="govuk-checkboxes">
										<div class="govuk-checkboxes__item">
											<input formControlName="tnc" class="govuk-checkboxes__input" id="tncPolicy"
												name="tncPolicy" type="checkbox" aria-required="true" />

											<label *ngIf="!adminJourney" class="govuk-label govuk-checkboxes__label"
												for="tncPolicy">
												{{ 'COMMON.POLICY_AGREE' | translate }}
											</label>

											<label *ngIf="adminJourney" class="govuk-label govuk-checkboxes__label"
												for="tncPolicy">
												{{ 'COMMON.POLICY_AGREE_ADMIN' | translate }}
											</label>
										</div>
									</div>
								</fieldset>
							</div>

							<div class="govuk-form-group" [ngClass]="{
									'govuk-form-group--error': submitted && form.data_policy.errors
								}">
								<fieldset class="govuk-fieldset" aria-describedby="data_policy">
									<legend
										class="govuk-fieldset__legend govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse">
										<h2>
											{{ 'COMMON.DATA_POLICY' | translate }}
										</h2>
									</legend>
									<p class="govuk-error-message" *ngIf="submitted && form.dataPolicyBox.errors">
										<span class="govuk-visually-hidden">Error:</span>
										{{ 'COMMON.IS_REQUIRED' | translate }}
									</p>

									<p class="govuk-body" [innerHTML]="selectedDepartment.extra.privacy_statement">
									</p>

									<div class="govuk-checkboxes" data-module="govuk-checkboxes">
										<div class="govuk-checkboxes__item">
											<input formControlName="dataPolicyBox" class="govuk-checkboxes__input"
												id="datapolicy" name="datapolicy" type="checkbox"
												aria-required="true" />

											<label *ngIf="!adminJourney"
												class="govuk-label govuk-checkboxes__label govuk-checkboxes__label--inverse"
												for="datapolicy">
												{{ 'COMMON.POLICY_AGREE' | translate }}
											</label>

											<label *ngIf="adminJourney"
												class="govuk-label govuk-checkboxes__label govuk-checkboxes__label--inverse"
												for="datapolicy">
												{{ 'COMMON.POLICY_AGREE_ADMIN' | translate }}
											</label>
										</div>
										<br />
										<p class="govuk-body" [innerHTML]="selectedDepartment?.extra?.summary_guidance">
										</p>
										<br />
									</div>
								</fieldset>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div class="row" *ngIf="paymentBlockedUnrecoverable">
				<div class="col-sm-12">
					<div class="govuk-error-summary" role="alert" aria-labelledby="payment-blocked-title" tabindex="-1">
						<h2 class="govuk-error-summary__title" id="payment-blocked-title">
							{{ 'COMMON.PAYMENT_BLOCKED_TITLE' | translate }}
						</h2>
						<div class="govuk-error-summary__body">
							<p class="govuk-body"><strong>{{ 'COMMON.PAYMENT_BLOCKED_NOT_CHARGED' | translate }}</strong></p>
							<p class="govuk-body">{{ 'COMMON.PAYMENT_BLOCKED_BODY' | translate }}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12">
					<button type="submit" class="btn btn-primary" *ngIf="!adminJourney && !checkoutFailed && preBasketRetryCount < 2"
						[disabled]="!confirmContinue || checkoutStarted" (click)="startCheckout(false)">
						<span style="color: #fff;" *ngIf="checkoutStarted">{{ 'COMMON.LOADING' | translate }}</span>
						<span style="color: #fff;" *ngIf="!checkoutStarted && preBasketRetryCount === 0">{{ 'COMMON.NEXT' | translate }}</span>
						<span style="color: #fff;" *ngIf="!checkoutStarted && preBasketRetryCount > 0">{{ 'COMMON.RETRY' | translate }}</span>
					</button>
					<button class="btn btn-primary" *ngIf="!adminJourney && (checkoutFailed || preBasketRetryCount >= 2)"
						(click)="restartJourney()">
						{{ 'COMMON.RESTART' | translate }}
					</button>
					<ng-container *ngIf="adminJourney && !checkoutFailed && preBasketRetryCount < 2">
						<button type="submit" class="btn btn-primary" style="margin-left: 0px;"
							[disabled]="!confirmContinue || checkoutStarted" (click)="startCheckout(true)">
							<span style="color: #fff;" *ngIf="checkoutStarted">{{ 'COMMON.LOADING' | translate }}</span>
							<span style="color: #fff;" *ngIf="!checkoutStarted && preBasketRetryCount === 0">{{ 'COMMON.ARP_PAYMENT' | translate }}</span>
							<span style="color: #fff;" *ngIf="!checkoutStarted && preBasketRetryCount > 0">{{ 'COMMON.RETRY' | translate }} {{ 'COMMON.ARP_PAYMENT' | translate }}</span>
						</button>
					</ng-container>
					<button class="btn btn-primary" style="margin-left: 0px;" *ngIf="adminJourney && (checkoutFailed || preBasketRetryCount >= 2)"
						(click)="restartJourney()">
						{{ 'COMMON.RESTART' | translate }}
					</button>
				</div>
			</div>
		</div>
	</div>
</main>
